import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";

interface CardProps {
	children: ReactNode;
	className?: string;
}

export function Card({ children, className = "" }: CardProps) {
	return (
		<div
			className={`rounded-2xl border border-border/60 bg-card card-pad shadow-card transition-shadow duration-200 ${className}`}
		>
			{children}
		</div>
	);
}

export function Brand({
	compactOnMobile = false,
}: { compactOnMobile?: boolean }) {
	const { t } = useTranslation("common");
	return (
		<div className="flex items-center gap-2.5 min-w-0">
			<div className="size-10 shrink-0 rounded-xl bg-gradient-brand flex items-center justify-center text-white text-lg font-black shadow-sm shadow-brand-600/30">
				K
			</div>
			{/* On a narrow header the name+tagline crowd the controls — hide on mobile. */}
			<div className={`${compactOnMobile ? "hidden sm:block" : ""} min-w-0`}>
				<h1 className="text-xl font-bold leading-tight truncate">Klyra</h1>
				<p className="text-xs text-muted-foreground leading-tight truncate">
					{t("app.tagline")}
				</p>
			</div>
		</div>
	);
}
